import { Modal, Form, InputNumber, Select, Button, Input } from "antd";
import { useState } from "react";

const { Option } = Select;


export const TopUpModal = ({ open, onCancel, onSubmit}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleFinish = async (values) => {
        setLoading(true);
        try {
            await onSubmit(values);
            form.resetFields();
            onCancel();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={open}
            title="Top Up Balance"
            onCancel={() => {
                form.resetFields();
                onCancel();

            }}
            footer={null}

        >
            <Form layout="vertical" form={form} onFinish={handleFinish}>
                <Form.Item
                    label="Amount"
                    name="amount"
                    rules={[
                        { required: true, message: "Please enter an amount" },
                        { type: "number", min: 1, message: "Amount must be at least 1" },
                    ]}
                >
                    <InputNumber style={{ width: "100%" }} placeholder="Enter amount" />
                </Form.Item>

                <Form.Item
                    label="Payment Method"
                    name="method"
                    rules={[{ required: true, message: "Please select a method" }]}
                >
                    <Select placeholder="Select method">
                        <Option value="crypto">Crypto</Option>
                        <Option value="online_transfer">Online Transfer</Option>
                    </Select>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        Submit
                    </Button>
                </Form.Item>

            </Form>
        </Modal>
    );
};
